import { render } from "./ModalCustomerValidationError.vue?vue&type=template&id=125e7564&scoped=true"
import script from "./ModalCustomerValidationError.vue?vue&type=script&lang=js"
export * from "./ModalCustomerValidationError.vue?vue&type=script&lang=js"

import "./ModalCustomerValidationError.vue?vue&type=style&index=0&id=125e7564&scoped=true&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125e7564"]])

export default __exports__